import { render, staticRenderFns } from "./FontType.vue?vue&type=template&id=e872f814&scoped=true&"
import script from "./FontType.vue?vue&type=script&lang=ts&"
export * from "./FontType.vue?vue&type=script&lang=ts&"
import style0 from "./FontType.vue?vue&type=style&index=0&id=e872f814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e872f814",
  null
  
)

export default component.exports